import { Injectable } from '@angular/core';
import { NotificationStore, MessageType } from './notification.store';
import { ToastAction } from 'src/app/shared/toast/toast.types';
import { UUIDService } from 'src/app/shared/uuid/uuid.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  constructor(private store: NotificationStore, private uuid: UUIDService) {}

  addMessage(
    scope: string,
    notification: {
      type: MessageType;
      isClose: boolean;
      message: string;
      title?: string;
      action?: ToastAction;
      duration?: number;
    }
  ): string {
    const id = this.uuid.get();
    this.store.add({
      id,
      scope,
      isClose: notification.isClose,
      type: notification.type,
      message: notification.message,
      title: notification.title,
      action: notification.action,
      duration: notification.duration
    });
    return id;
  }

  removeById(id: string): void {
    this.store.remove(id);
  }

  removeByScope(scope: string): void {
    this.store.remove(entity => entity.scope === scope);
  }

  removeByScopeAndType(scope: string, type: MessageType): void {
    this.store.remove(entity => entity.scope === scope && entity.type === type);
  }
}
